import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.spinner-color]': 'spinnerColor',
    '[class]': 'variant',
  },
})
export class SpinnerComponent {
  public static readonly VARIANTS: Variants = ['default', ['default', 'small', 'small-x']];
  @ComponentVariant(SpinnerComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public spinnerColor: boolean = false;
  @Input() public animate: boolean = true;

  constructor(public elRef: ElementRef) {}
}
